import React from 'react'
import { Link } from 'react-router-dom';
import { getImageUrl } from '../../utils/imageUrl';

function ServiceCard(props) {
    const { serviceID, serviceImage, serviceTitle, serviceItem } = props;
    return (
            <div className="destination-item th-ani">
                <div className="destination-item_img global-img">
                    <img src={getImageUrl(serviceImage, 'destination')} alt="" />
                </div>
                <div className="destination-content">
                    <h3 className="box-title">
                        <Link to={`/service/${serviceID}`}>{serviceTitle}</Link>
                    </h3>
                    {serviceItem && <p className="destination-text">{serviceItem}</p>}
                    <Link to="/contact" className="th-btn style4 th-icon">
                        Book Now
                    </Link>
                </div>
            </div>
    )
}

export default ServiceCard
